import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class FarmacosService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/obtenerPlanTratamientoPaciente',
    });
  }

  obtenerPlanTratamiento(idPaciente: string): any {
    return this._http.post(environment.api_host + 'farmacos/obtenerPlanTratamiento', {idPaciente: idPaciente}).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
}



// WEBPACK FOOTER //
// ./src/services/farmacos.service.ts